/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
const c="20211209",b="84d3b592e14ffc7448dfe33171da130bb6c80c65";export{c as buildDate,b as commitHash};
